import {HttpClient,HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SERVER_API_URL} from 'src/app/app.constants';
import {ICountryMySuffix} from 'src/app/shared/model/country-my-suffix.model';
import {createRequestOption} from 'src/app/shared/util/request-util';
import {StateStorageService} from './../../core/auth/state-storage.service';
import { TreeviewItem } from 'ngx-treeview';
import { map } from 'rxjs-compat/operator/map';
import * as cloneDeep from 'lodash/cloneDeep';

type EntityResponseType = HttpResponse<ICountryMySuffix>;
type EntityArrayResponseType = HttpResponse<ICountryMySuffix[]>;

@Injectable({ providedIn: 'root' })
export class CountryMySuffixService {
    private resourceUrl = SERVER_API_URL + 'api/countries';
    private resourceOpenUrl = SERVER_API_URL + 'api/open/countries';

    private spotClientResourceUrl = SERVER_API_URL + 'api/spot-countries';

    private countriesByContinents  = SERVER_API_URL +'api/users/get-country-cont-reg';
    private _checkedCountriesByContinents = SERVER_API_URL + 'api/countries/continent?existingCountriesId=';

    constructor(private http: HttpClient,private stateStorage:StateStorageService) {}

    create(country: ICountryMySuffix): Observable<EntityResponseType> {
        return this.http.post<ICountryMySuffix>(this.resourceUrl, country, { observe: 'response' });
    }

    update(country: ICountryMySuffix): Observable<EntityResponseType> {
        return this.http.put<ICountryMySuffix>(this.resourceUrl, country, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<ICountryMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        let countries=this.stateStorage.getCountries();
        if(countries) {
            console.log("getting from session storage");
            return Observable.of(countries);
            // return Observable<HttpResponse>.create(countries);
        } else {
            const countryPagination={
                page: 0,
                size: 300
            };
            const options=createRequestOption(countryPagination);
            return this.http.get<ICountryMySuffix[]>(this.resourceUrl,{params: options,observe: 'response'});
        }
    }

    queryOpen(req?: any): Observable<EntityArrayResponseType> {
        const countryPagination = {
            page: 0,
            size: 300
        };
        const options = createRequestOption(countryPagination);
   
        return this.http.get<ICountryMySuffix[]>(this.resourceOpenUrl, { params: options, observe: 'response' });
    }
    
    spotQuery(req?: any): Observable<EntityArrayResponseType> {

        let countries=this.stateStorage.getCountries();
        if(countries) {
            console.log("getting from session storage");
            return Observable.of(countries);
            // return Observable<HttpResponse>.create(countries);
        } else {
            const countryPagination={
                page: 0,
                size: 300
            };
            const options=createRequestOption(countryPagination);
            return this.http.get<ICountryMySuffix[]>(this.spotClientResourceUrl,{params: options,observe: 'response'});
        }
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    countriesHavingNoTax(req?: any): Observable<EntityArrayResponseType> {
        const countryPagination = {
            page: 0,
            size: 300
        };
        const options = createRequestOption(countryPagination);
        return this.http.get<ICountryMySuffix[]>(SERVER_API_URL + 'api/countries/noTax', { params: options, observe: 'response' });
    }

    countriesHavingNoWarStrike(req?: any): Observable<EntityArrayResponseType> {
        const countryPagination = {
            page: 0,
            size: 300
        };
        const options = createRequestOption(countryPagination);
        return this.http.get<ICountryMySuffix[]>(SERVER_API_URL + 'api/countries/noWarStrike', { params: options, observe: 'response' });
    }

    getByUrl(url?: any): Observable<any> {
        return this.http.get<any>(SERVER_API_URL  + url, { observe: 'response' });
    }

    getStatesByCountryId(id: number) {
        let states=this.stateStorage.getStates();
        if(states) {
            console.log("getting state from storage");
            return Observable.of(states);
            // return Observable<HttpResponse>.create(countries);
        }
         else {
            let url="api/countries/"+id+"/state"
            return this.http.get<any>(SERVER_API_URL+url,{observe: 'response'});
        }
    }

    getStatesByCountryIdWithoutAuth(id:number){
        let url =  this.spotClientResourceUrl+"/"+id+"/state"
         return this.http.get<any>(   url, { observe: 'response' });
     }

    getCountriesWithContinents() {
        let countries=this.stateStorage.getCountriesWithContinent();
        if(countries) {
            console.log("getting from session storage");
            return Observable.of(cloneDeep(countries));
        } else {
            return this.http.get<any>(this.countriesByContinents, {observe : 'response'});
        }
    }

    getCountriesWithContinentsByRuleId(id:number,type:string) {
        return this.http.get<any>(this.countriesByContinents+'/'+id+'/'+type, {observe : 'response'});
    }

    getCountriesWithContinentInTreeView(id: any[]) {
       return this.getCountriesWithContinents().map(res => {
           let countries = res.body;
            console.warn(countries);
            if(countries && countries.length > 0) {
                this.mapToTreeViewItem(id, countries);
            }
            return countries;
        });
    }

    mapToTreeViewItem(countriesId: any, data: any) {
        for(let i = 0; i < data.length; i++) {
            data[i] = new TreeviewItem(data[i]);
            if(data[i].children && data[i].children.length > 0) {
                for(let j = 0; j < data[i].children.length; j++) {
                    data[i].children[j] = new TreeviewItem(data[i].children[j]);
                    if(data[i].children[j].children && data[i].children[j].children.length > 0) {
                        for(let k = 0; k < data[i].children[j].children.length; k++) {
                            let d = data[i].children[j].children[k];
                            data[i].children[j].children[k] = new TreeviewItem(d);
                            if(countriesId && countriesId.length > 0 && countriesId.includes(d.value)) {
                                d.checked = true;
                            }
                        }
                    }
                }
            }
        }
        return data;
    }

    getCheckedCountriesByContinents(id: any[]) {
        return this.http.get<any>(this._checkedCountriesByContinents+id, {observe : 'response'});
    }
}
